<template>
  <div class="logo-picker">
    <span class="logo-frame" aria-hidden="true">
      <img v-if="preview" :src="preview" alt="">
      <i v-else class="mdi mdi-image-outline"></i>
    </span>
    <div class="logo-controls">
      <div class="pb-actions">
        <label class="pb-file">
          <input type="file" accept="image/png,image/jpeg,image/webp" :aria-labelledby="labelledBy" @change="pick">
          <span class="pb-button outline sm"><i class="mdi mdi-upload pb-ico" aria-hidden="true"></i>{{ preview ? 'Replace logo' : 'Upload a logo' }}</span>
        </label>
        <button v-if="value" type="button" class="pb-button ghost sm" @click="clear">Remove</button>
      </div>
      <span v-if="status" class="pb-help">{{ status }}</span>
      <span v-if="error" class="pb-field-error">{{ error }}</span>
      <span v-else class="pb-help">PNG, JPG or WebP, up to 5 MB. A square logo works best.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoPicker',
  props: {
    value: { type: Object, default: null },
    current: { type: String, default: '' },
    status: { type: String, default: '' },
    labelledBy: { type: String, default: null },
    maxBytes: { type: Number, default: 5 * 1024 * 1024 }
  },
  data: () => ({ error: '' }),
  computed: { preview() { return (this.value && this.value.preview) || this.current; } },
  // The preview URL belongs to the v-model value, which can outlive this picker (onboarding keeps showing the logo
  // in its phone preview after the brand step, and Back shows it here again). So it is revoked only when the logo is
  // replaced or removed here, never when the picker unmounts.
  methods: {
    pick(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = '';
      this.error = '';
      if (!file) return;
      if (['image/png', 'image/jpeg', 'image/webp'].indexOf(file.type) < 0) { this.error = 'Use a PNG, JPG or WebP image.'; return; }
      if (file.size > this.maxBytes) { this.error = 'That image is larger than ' + Math.round(this.maxBytes / 1048576) + ' MB. Choose a smaller file.'; return; }
      if (this.value && this.value.preview) URL.revokeObjectURL(this.value.preview);
      this.$emit('input', { file, preview: URL.createObjectURL(file) });
    },
    clear() {
      if (this.value && this.value.preview) URL.revokeObjectURL(this.value.preview);
      this.$emit('input', null);
    }
  }
};
</script>

<style scoped>
.logo-picker{display:flex;align-items:flex-start;gap:16px}
.logo-frame{display:inline-grid;place-items:center;flex:0 0 64px;width:64px;height:64px;border-radius:14px;border:1px dashed #D4C9B8;background:#fff;color:#8C8378;font-size:26px;overflow:hidden}
.logo-frame img{width:100%;height:100%;object-fit:contain}
.logo-controls{display:flex;flex-direction:column;gap:2px;min-width:0}
</style>
